export const dataURItoByteArray = (dataURI: string) => {
    try {
        const byteString = atob(dataURI.split(',')?.[1]);

        const stringBuffer = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(stringBuffer);

        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return ia;
    } catch {
        return null;
    }
};
